import DraftEmailContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DraftEmailContent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import KeyDecisionContentEvent from "../event/KeyDecisionContentEvent";
import KeyDecisionsConfig from "../model/KeyDecisionsConfig";
import KeyDecisionsModel from "../model/KeyDecisionsModel";
import KeyDecisionAnswer from "../model/KeyDecisionAnswer";
import MCBlock from "../../../../../lib/html5-software-library/src/ranj/eng/content/MCBlock";
import NGTVariableManager from "../../../ngt/base/NGTVariableManager";

export default class KeyDecisionContentCompletedCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {KeyDecisionsModel} keyDecisionsModel 
     * @param {KeyDecisionsConfig} keyDecisionsConfig 
     * @param {NGTVariableManager} variableManager 
     */
    constructor(dispatcher, keyDecisionsModel, keyDecisionsConfig, variableManager) {
        super(dispatcher);

        this._keyDecisionsModel = keyDecisionsModel;
        this._keyDecisionsConfig = keyDecisionsConfig;
        this._variableManager = variableManager;
    }

    execute(evt) {
        /** @type {KeyDecisionContentEvent} */
        const data = evt.params.data;
        const keyDecisionContent = data.content;
        let keyDecision = this._keyDecisionsModel.getAvailableKeyDecisionByContent(keyDecisionContent);
        keyDecision = this._processKeyDecision(keyDecisionContent, keyDecision);
        this._generateStoryVariablesFromPlayerAnswers(keyDecision);
        console.log(`[KeyDecisionContentCompletedCommand] Key decision with content id '${keyDecisionContent.getContentID()}' becomes completed.`);
        this._keyDecisionsModel.completeKeyDecision(keyDecision);
    }

    _generateStoryVariablesFromPlayerAnswers(keyDecision) {
        for (let playerAnswer of keyDecision.playerAnswers) {
            let id = playerAnswer.id;
            if (id != null && id != "") {
                this._variableManager.setVariable(id, true);
            }
        }
    }

    _processKeyDecision(content, keyDecision) {
        // For Email Key Decision
        if (content instanceof DraftEmailContent) {
            var optimalAnswers = [];
            var playerAnswers = [];
            var contentBlocks = content.getContentBlocks().filter(cb => cb instanceof MCBlock);
            for (let contentBock of contentBlocks) {
                let selectedContentBlockIndex = contentBock.getSelectedOptionIndex();
                let optionsContentBlock = contentBock.getOptions();
                for (let i = 0; i < optionsContentBlock.length; i++) {
                    let optionContentBlock = optionsContentBlock[i];
                    let id = optionContentBlock.getDescription().getContentID();
                    let answer = optionContentBlock.getDescription().getText();
                    let rating = optionContentBlock.getDescription().getBalloonType();
                    let feedback = optionContentBlock.getValue().getText();
                    if (rating == KeyDecisionAnswer.GOOD_RATING) {
                        optimalAnswers.push(new KeyDecisionAnswer(id, answer, feedback, rating));
                    }
                    if (i == selectedContentBlockIndex) {
                        playerAnswers.push(new KeyDecisionAnswer(id, answer, feedback, rating));
                    }
                }
            }
            keyDecision.optimalAnswers = optimalAnswers;
            keyDecision.playerAnswers = playerAnswers;

        } else {
            // For Plan Composer Key Decision
            keyDecision.optimalAnswers = content.optimalAnswers;
            keyDecision.playerAnswers = content.playerAnswers;
        }
        return keyDecision;
    }
}